import React from 'react';

export default function TextInputSubmitOnEnterLeadingIcon({
  id,
  placeholder,
  value,
  textColour = "dark-grey",
  bgColour = "white",
  rounded = "full",
  placeholderColour = "dark-grey/50",
  widthClass = "w-fit",
  borderClass = "border-none",
  icon,
  onChange = () => { },
  onClick = () => { },
  loading,
  shadow = "none"
}: {
  id: string;
  placeholder: string;
  /**
   * Pass to run controlled — the parent then owns the text and it survives a
   * submit. Omit to keep the original uncontrolled behaviour, where the field
   * clears itself after submitting (still what Home wants, since it navigates
   * away immediately afterwards).
   */
  value?: string;
  bgColour?: string;
  rounded?: string;
  textColour?: string;
  /**
   * Border utilities, as a full class string like Dropdown takes -- e.g.
   * "border border-dark-grey". Defaults to none: the hero search boxes sit on
   * a dark panel and read as a field without one.
   */
  borderClass?: string;
  placeholderColour?: string;
  widthClass?: string;
  icon: React.ReactNode;
  onChange?: (e: any) => void;
  onClick?: () => void;
  loading: boolean;
  shadow?: string;
}) {

  const isControlled = value !== undefined;

  // Add event listener to input field for when Enter is pressed
  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  }

  function handleSubmit() {
    onClick();
    if (isControlled) {
      // The parent decides what the field shows after a submit. Blanking the DOM
      // node here is what wiped the query out of the search box on /search, even
      // though the query stayed in the URL.
      return;
    }
    const inputField = document.getElementById(`${id}-text-input`) as HTMLInputElement | null;
    if (inputField) {
      inputField.value = "";
    }
  }

  return (
    <div className={`grid grid-cols-1 ${widthClass}`}>
      <input
        id={`${id}-text-input`}
        type="text"
        placeholder={placeholder}
        className={`col-start-1 shadow-${shadow} row-start-1 block w-full rounded-${rounded} bg-${bgColour} py-1.5 pl-10 pr-3 text-base text-${textColour} outline ${borderClass} outline-none placeholder:text-${placeholderColour} focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-dark-grey sm:pl-9 text-xs sm:text-sm/6`}
        {...(isControlled ? { value } : {})}
        onChange={onChange}
        onKeyDown={handleKeyPress}
        disabled={loading}
      />
      {icon}
    </div>
  )
}
